import {
  OptionBox,
  OptionCard,
  OptionColor,
  OptionIcon,
  OptionImage,
  OptionPalette,
  OptionSimple,
} from '@dbi-tools/ui-kit/lib/options';
import React from 'react';

import { Option, Question } from '../types';

const Control: React.FC<{
  question: Question;
  maxAnswers?: number;
  option: Option;
}> = ({ option, question: { name, maxAnswers, optionsType, showLabels } }) => {
  const { id, label, icon, metadata, image, disabled, color, simpleElement = false } = option;

  const commonProps = { id, value: id, label, color, icon, name, simpleElement, radio: maxAnswers === 1, disabled };

  if (optionsType === 'simple') {
    return <OptionSimple {...commonProps} pb={20} />;
  } else if (optionsType === 'simple-bordered') {
    return <OptionBox {...commonProps} pb={20} />;
  } else if (optionsType === 'images') {
    return <OptionImage {...commonProps} image={image} showLabel={showLabels} />;
  } else if (optionsType === 'cards') {
    return <OptionCard {...commonProps} image={image} withMobileView pb={20} />;
  } else if (optionsType === 'palettes') {
    return <OptionPalette {...commonProps} colors={metadata?.colors} pb={20} />;
  } else if (optionsType === 'icons') {
    return <OptionIcon {...commonProps} pb={20} />;
  } else if (optionsType === 'colors') {
    return <OptionColor {...commonProps} pb={20} />;
  }
};

export default Control;
